module.exports = __webpack_public_path__ + "static/media/settingTeamInActive.bc814553.png";